import { createSlice } from '@reduxjs/toolkit';


export const GlobalComponentSlice = createSlice({

    name: 'GlobalComponentManagment',
    initialState: {
        croppedImage : '',
        croppedImgIdx : ''
    },

    reducers: {
        setCroppedImg: (state, action) => {
                const { index, dataUrl } = action.payload;
                state.croppedImage = dataUrl;
                state.croppedImgIdx = index
        },
        clearCroppedImg: (state, action) => {
            state.croppedImage = '';
            state.croppedImgIdx = '';
        }
     
    },

  
})

export const { setCroppedImg, clearCroppedImg } = GlobalComponentSlice.actions
export default GlobalComponentSlice.reducer